import { z } from 'zod';
import { auditFieldsSchema, idSchema } from './primitives';

/**
 * Link utile: un nome leggibile e l'indirizzo web a cui porta (portale del
 * bando, normativa, area riservata dell'ente). Condiviso da template e
 * progetto, che ne hanno ciascuno il proprio elenco.
 */
export const linkUtileCreateSchema = z.object({
  nome: z.string().trim().min(1).max(120),
  // Solo http/https: un `javascript:` o un `file:` aperti da un click non sono un link utile.
  url: z
    .url({ protocol: /^https?$/, error: 'Inserisci un indirizzo web completo, es. https://…' })
    .max(2000),
});
export type LinkUtileCreate = z.infer<typeof linkUtileCreateSchema>;

export const linkUtileUpdateSchema = linkUtileCreateSchema.partial();
export type LinkUtileUpdate = z.infer<typeof linkUtileUpdateSchema>;

export const linkUtileSchema = linkUtileCreateSchema.extend({
  id: idSchema,
  ...auditFieldsSchema.shape,
});
export type LinkUtile = z.infer<typeof linkUtileSchema>;
